import { useState, useEffect } from 'react';
import { getAnimationClass } from './../utils';

export default function NormTricky({ onComplete }) {
  const [showP, setShowP] = useState(false);
  const [showDefferedContraAccounts, setShowDefferedContraAccounts] = useState(false);


  useEffect(() => {
    const timeouts = [];
    let currentTime = 500;
    
    timeouts.push(setTimeout(() => setShowP(true), currentTime));
        
    currentTime += 5000;
    timeouts.push(setTimeout(() => setShowDefferedContraAccounts(true), currentTime));
    
    currentTime += 15000;
    timeouts.push(setTimeout(() => onComplete?.(), currentTime));
    
    return () => timeouts.forEach(clearTimeout);
  }, [onComplete]);

  return (
    <>
      <h1 className="animate-fade-in">The Normal Balance of  Tricky Accounts</h1>
      
      <p className={getAnimationClass(showP)}>
        In this level, you’ll have to sort deferred and contra accounts to their correct normal balances. This can be tricky because these accounts may sound similar but function differently.
      </p>

      {showDefferedContraAccounts && (
        <div className={`transition-deferred-contra-accounts ${getAnimationClass(showDefferedContraAccounts)}`}>
          <div className="transition-deferred-contra-account deferred-account">
            <h4>Deferred Accounts</h4>
            <p>A Deferred account refers to an account used when cash is received in advance before revenue is earned or paid in advance before an expense is incurred.</p>
          </div>
          <div className="transition-deferred-contra-account contra-account">
            <h4>Contra Accounts</h4>
            <p>A Contra Account refers to an account associated to another account and is used to reduce the value of that associated account.  It’s normal balance is opposite of the associated account.</p>
          </div>
        </div>
      )}
    </>
  );
}